var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"static-page"},[_c('div',{staticClass:"columns is-centered is-fullheight"},[_c('div',{staticClass:"static-page-title-container"},[_c('h1',[_vm._v("\n          "+_vm._s(_vm.page.title)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.page.html)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }